import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getUserResponseToQuestion = (
  questionID,
  pageNum,
  pageSize,
  filterParam,
  userName
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.QUIZ_REPORT.GET_USER_RESPONSE_TO_QUESTIONS(
      questionID,
      pageNum,
      pageSize,
      filterParam,
      userName
    ),
    "",
    cancelToken
  );
};

export default getUserResponseToQuestion;
